var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-page"},[_c('Listener',{attrs:{"disable_extension_selector":true,"data-test-id":"apps-show-page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }